module.exports = __webpack_public_path__ + "static/img/static/img/pre_right.d143cae1.png";